import { useEffect } from "react";
import { useApolloClient } from "@apollo/client";
import { useAppDispatch } from "../../hooks";
import { setNotification } from "../../../store/slices/inAppNotification";
import { USER_NOTIFICATION_SUBSCRIPTION } from "@onmo/graphql/legacyGraphql";
import { NotificationTypeInTGP } from "../../../models/notification";
import { UserNotificationType } from "@onmo/graphql/legacy-graphql-hook";
import { getUserProfileTgpGQL, meGQL } from "../../../graphql";

export const NotificationSubscription = () => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();

  const subscribe = () => {
    return client
      .subscribe({
        query: USER_NOTIFICATION_SUBSCRIPTION,
        fetchPolicy: "network-only",
      })
      .subscribe({
        next: (data) => {
          const notiData = data.data?.userNotificationCreated;
          const isValid = NotificationTypeInTGP.includes(notiData.type);
          dispatch(setNotification({ data: isValid && notiData }));
          localStorage.setItem("has_unread", "1");
          if (notiData.type === UserNotificationType.AchievementReward) {
            client.refetchQueries({ include: [getUserProfileTgpGQL, meGQL] });
          }
        },
        error: (err) => {
          console.error("Subscription error:", err);
        },
      });
  };

  useEffect(() => {
    let intervalId: string | number | NodeJS.Timeout | undefined;
    // subscribe at the beginning
    let subscription = subscribe();
    // re-subscribe after 5min
    const subscribeAndResubscribe = () => {
      intervalId = setInterval(() => {
        subscription.unsubscribe();
        subscription = subscribe();
      }, 300000);
    };
    subscribeAndResubscribe();
    // re-subscribe after 30s
    const timeoutId = setTimeout(() => {
      subscription.unsubscribe();
      subscription = subscribe();
    }, 30000);

    return () => {
      timeoutId && clearTimeout(timeoutId);
      intervalId && clearInterval(intervalId);
    };
  }, []);

  return <div data-testid="notification-subscription"></div>;
};
